"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indicators = exports.ButtonRight = exports.ButtonLeft = exports.Controller = exports.Item = exports.CarouselBody = exports.CarouselWrapper = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  bottom: 3%;\n  left: 0;\n  z-index: 100;\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  li {\n    box-sizing: content-box;\n    width: 0.5rem;\n    height: 0.5rem;\n    border-radius: 100%;\n    margin-right: 2%;\n    margin-left: 2%;\n    cursor: pointer;\n    background-color: ", ";\n    background-clip: padding-box;\n    opacity: 0.5;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  z-index: 100;\n  position: absolute;\n  width: 3rem;\n  padding: 0.5rem;\n  height: 100%;\n  top: 0;\n  right: ", ";\n  transform: ", ";\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  :active,\n  :focus {\n    outline: none;\n  }\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  z-index: 100;\n  position: absolute;\n  width: 3rem;\n  padding: 0.5rem;\n  height: 100%;\n  top: 0;\n  left: ", ";\n  transform: ", ";\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  :active,\n  :focus {\n    outline: none;\n  }\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  position: inherit;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: ", ";\n  min-width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & > * {\n    width: ", ";\n    height: ", ";\n    object-fit: cover;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: ", ";\n  width: 100%;\n  height: 100%;\n  display: flex;\n  transform: translate3d(0, 0, 0);\n  transform-style: preserve-3d;\n  backface-visibility: hidden;\n  will-change: transform;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n\n  .active {\n    opacity: 1;\n  }\n\n  .fade-out {\n    opacity: 0;\n    animation: fade-out ", "ms linear;\n  }\n\n  .fade-in {\n    opacity: 1;\n    animation: fade-in ", "ms linear;\n  }\n\n  .slide {\n    transition: transform ", "ms linear;\n  }\n\n  @keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-out {\n    0% {\n      opacity: 1;\n    }\n\n    100% {\n      opacity: 0;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.width ? props.width : "100%";
}, function (props) {
  return props.height ? props.height : "100%";
});

exports.Container = Container;

var CarouselWrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.speed;
}, function (props) {
  return props.speed;
}, function (props) {
  return props.speed;
});

exports.CarouselWrapper = CarouselWrapper;

var CarouselBody = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.effect === "fade" ? "absolute" : "relative";
});

exports.CarouselBody = CarouselBody;

var Item = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.background ? props.background : "white";
}, function (props) {
  return props.fitWidth ? "100%" : "unset";
}, function (props) {
  return props.fitHeight ? "100%" : "unset";
});

exports.Item = Item;

var Controller = _styledComponents["default"].div(_templateObject5());

exports.Controller = Controller;

var ButtonLeft = _styledComponents["default"].button(_templateObject6(), function (props) {
  return props.buttonPosition === "outside" ? "-5%" : "5%";
}, function (props) {
  return props.buttonPosition === "outside" ? "translateX(-100%)" : "translateX(0)";
}, function (props) {
  return props.buttonColor ? props.buttonColor : "black";
});

exports.ButtonLeft = ButtonLeft;

var ButtonRight = _styledComponents["default"].button(_templateObject7(), function (props) {
  return props.buttonPosition === "outside" ? "-5%" : "5%";
}, function (props) {
  return props.buttonPosition === "outside" ? "translateX(100%)" : "translateX(0)";
}, function (props) {
  return props.buttonColor ? props.buttonColor : "black";
});

exports.ButtonRight = ButtonRight;

var Indicators = _styledComponents["default"].ol(_templateObject8(), function (props) {
  return props.indicatorsColor ? props.indicatorsColor : "black";
});

exports.Indicators = Indicators;